import styled from '@emotion/styled';
import Image from 'next/image';
import { InnerContent, InnerTitle, TextWrapper } from '..';
import pcceCertificate from './pcce-certificate.png';
import pcceResult from './pcce-result.png';
import pccpCertificate from './pccp-certificate.png';
import pccpResult from './pccp-result.png';
import pcsqlCertificate from './pcsql-certificate.png';
import pcsqlResult from './pcsql-result.png';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const Container = styled.div`
display: grid;
row-gap: 16px;
`;

const ExampleContainer = styled.div`
display: grid;
padding: 40px;
background-color: ${colors.lightGrey5};
column-gap: 106px;
grid-template-columns: auto auto;
place-content: center;

@media (max-width: ${breakpointSmall}) {
  padding: 32px 40px;
  grid-template-columns: 1fr;
  row-gap: 32px;
}
`;

const Example = styled.div`
display: grid;
justify-items: center;
row-gap: 10px;
`;

const ImageContainer = styled.div`
max-width: 300px;
max-height: 424px;

@media (max-width: ${breakpointSmall}) {
  max-width: 240px;
  max-height: 339px;
}
`;

const Description = styled.span`
color: ${colors.darkGrey};
font-size: 13px;
`;

export const PCCPCertificate = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>성적표﹒인증서 양식</InnerTitle>
      <InnerContent>프로그래머스 코딩전문역량인증(PCCP) 합격 시 성적표∙인증서를 발급 받으실 수 있습니다.</InnerContent>
    </TextWrapper>
    <ExampleContainer>
      <Example>
        <ImageContainer>
          <Image
            src={pccpResult}
            alt="pccp result"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </ImageContainer>
        <Description>PCCP 성적표</Description>
      </Example>
      <Example>
        <ImageContainer>
          <Image
            src={pccpCertificate}
            alt="pccp certificate"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </ImageContainer>
        <Description>PCCP 인증서</Description>
      </Example>
    </ExampleContainer>
  </Container>
);

export const PCCECertificate = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>성적표﹒인증서 양식</InnerTitle>
      <InnerContent>프로그래머스 코딩필수역량인증(PCCE) 합격 시 성적표∙인증서를 발급 받으실 수 있습니다.</InnerContent>
    </TextWrapper>
    <ExampleContainer>
      <Example>
        <Image
          src={pcceResult}
          width={300}
          height={424}
          style={{ maxWidth: '100%', height: 'auto' }}
          alt="pcce result"
        />
        <Description>PCCE 성적표</Description>
      </Example>
      <Example>
        <Image
          src={pcceCertificate}
          width={300}
          height={424}
          style={{ maxWidth: '100%', height: 'auto' }}
          alt="pcce certificate"
        />
        <Description>PCCE 인증서</Description>
      </Example>
    </ExampleContainer>
  </Container>
);

export const PCSQLCertificate = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>성적표﹒인증서 양식</InnerTitle>
      <InnerContent>프로그래머스 SQL역량인증(PCSQL) 합격 시 성적표∙인증서를 발급 받으실 수 있습니다.</InnerContent>
    </TextWrapper>
    <ExampleContainer>
      <Example>
        <Image
          src={pcsqlResult}
          width={300}
          height={424}
          style={{ maxWidth: '100%', height: 'auto' }}
          alt="pcsql result"
        />
        <Description>PCSQL 성적표</Description>
      </Example>
      <Example>
        <Image
          src={pcsqlCertificate}
          width={300}
          height={424}
          style={{ maxWidth: '100%', height: 'auto' }}
          alt="pcsql certificate"
        />
        <Description>PCSQL 인증서</Description>
      </Example>
    </ExampleContainer>
  </Container>
);
